module.exports = __webpack_public_path__ + "img/horizontal_3_4_pp12_3.b285a744.png";